import Vue from 'vue';
import moment from 'moment-es6';

require('moment/locale/ru');
require('moment/locale/id');

Vue.use(require('vue-moment'), {
  moment
});

Vue.moment.locale('ru');
